<button
  [ngClass]="{ 'navbar-btn': true, 'navbar-btn-confirm': type() === 'confirm' }"
  (click)="click($event)"
  [attr.data-active]="active()">
  <i [ngClass]="[icon()]" aria-hidden="true" [attr.data-count]="count()" [attr.data-count-hidden]="hideCount()"></i>
  <span>{{ label() }}</span>
</button>
